import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Send, Trash2 } from 'lucide-react';
import { thClass, tdClass, euro } from './adminUi';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminAbandonedCarts = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () =>
    axios
      .get(`${API}/admin/abandoned-carts`)
      .then((r) => setItems(Array.isArray(r.data) ? r.data : r.data.carts || []))
      .catch(() => toast.error('Échec du chargement des paniers abandonnés'))
      .finally(() => setLoading(false));

  useEffect(() => {
    load();
  }, []);

  const relancer = async (c) => {
    try {
      await axios.post(`${API}/admin/abandoned-carts/${encodeURIComponent(c.id)}/relance`);
      toast.success(`Relance envoyée à ${c.email}`);
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur');
    }
  };

  const remove = async (c) => {
    if (!window.confirm(`Supprimer le panier abandonné de ${c.email} ?`)) return;
    try {
      await axios.delete(`${API}/admin/abandoned-carts/${encodeURIComponent(c.id)}`);
      toast.success('Panier supprimé');
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur');
    }
  };

  return (
    <div data-testid="admin-abandoned-carts">
      <h2 className="font-heading text-2xl mb-6">Paniers abandonnés</h2>
      {loading ? (
        <p className="text-foreground/40">Chargement…</p>
      ) : items.length === 0 ? (
        <p className="text-foreground/40 py-8">Aucun panier abandonné.</p>
      ) : (
        <div className="overflow-x-auto border border-black/10">
          <table className="w-full">
            <thead>
              <tr>
                <th className={thClass}>Email</th>
                <th className={thClass}>Articles</th>
                <th className={thClass}>Total</th>
                <th className={thClass}>Statut</th>
                <th className={thClass}>Mis à jour</th>
                <th className={thClass}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id}>
                  <td className={tdClass}>{c.email}</td>
                  <td className={tdClass}>{(c.items || []).reduce((n, i) => n + (i.quantity || 1), 0)}</td>
                  <td className={tdClass}>{c.total != null ? euro(c.total) : '—'}</td>
                  <td className={tdClass}>
                    <span className={c.status === 'relanced' ? 'text-gold' : 'text-foreground/50'}>
                      {c.status === 'relanced' ? 'Relancé' : 'En attente'}
                    </span>
                  </td>
                  <td className={tdClass}>{(c.updated_at || '').slice(0, 16).replace('T', ' ')}</td>
                  <td className={`${tdClass} whitespace-nowrap`}>
                    <button onClick={() => relancer(c)} className="text-foreground/60 hover:text-gold mr-3 inline-flex items-center gap-1 text-sm" data-testid="abcart-relance">
                      <Send size={14} /> Relancer
                    </button>
                    <button onClick={() => remove(c)} className="text-foreground/50 hover:text-red-400"><Trash2 size={16} /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminAbandonedCarts;
